import { render, staticRenderFns } from "./OrganizationSettingsAgreement.vue?vue&type=template&id=06ba15ae&scoped=true"
import script from "./OrganizationSettingsAgreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsAgreement.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsAgreement.vue?vue&type=style&index=0&id=06ba15ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba15ae",
  null
  
)

export default component.exports